/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {FlatList, Platform, Text, TouchableOpacity, View} from 'react-native';
import {styles} from './styles';
import globalStyle from '../../../styles/globalStyle';
import { Loader } from '../../Loader';

export default function SinistreListComponent(props: any) {
  const {datas, isLoading, handleClick} = props;

  const handleMove = ({item}: {item: any}) => {
    handleClick(item);
  };
  const containerStyle =
    Platform.OS === 'web'
      ? [
          styles.ListContainer,
          globalStyle.containerFluid,
          globalStyle.fullEcranWeb,
        ]
      : styles.ListContainer;
  return (
    <View style={containerStyle}>
      {isLoading ? (
        <Loader />
      ) : (
        <FlatList
          data={datas || []}
          renderItem={({item}: {item: any}) => (
            <TouchableOpacity
              style={styles.ListItemInRow}
              onPress={() => {
                handleMove({item});
              }}>
              <View
                style={[
                  Platform.OS === 'web' && {width: 700},
                  {flex: 1, flexDirection: 'row', justifyContent: 'center'},
                ]}>
                <View style={{flex: 1, flexDirection: 'column'}}>
                  <Text style={styles.titleBlue}>{item.type}</Text>
                  <Text style={styles.ListItemFont}>{item.numeroPolice}</Text>
                </View>
                <View
                  style={{
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                  }}>
                  <Text style={styles.ListItemFontStateTrue}>
                    {item.statut}
                  </Text>
                  <Text style={styles.ListItemFontDate}>{item.date}</Text>
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      )}
    </View>
  );
};
